// Iteration 86 — checkpoint: force-gregorian-dates-and-admin-whatsapp-links
//
// Shared frontend helper to build a direct wa.me URL from a customer's
// stored phone value. Reused across Admin > الحجوزات, Admin > سجل العملاء,
// and Admin > المهام (جلسات اليوم). Purely a convenience URL — does NOT
// hit Twilio, does NOT send any message, and does NOT touch the stored
// phone value in MongoDB.

/**
 * Normalize a raw phone string into the digits-only form expected by
 * wa.me. Rules:
 *   - strip everything that isn't a digit (spaces, brackets, dashes, +)
 *   - convert a leading `00` international prefix to nothing (00966… → 966…)
 *   - convert a leading Saudi local `0` (05xxxxxxxx) to `966` (9665xxxxxxxx)
 *   - preserve any other already-international number as-is
 *   - reject strings that don't have at least 8 digits after normalization
 */
export function normalizeWhatsappNumber(raw) {
  if (raw === undefined || raw === null) return "";
  let digits = String(raw).replace(/\D+/g, "");
  if (!digits) return "";
  // 00 international prefix → drop it
  if (digits.startsWith("00")) {
    digits = digits.slice(2);
  } else if (digits.startsWith("0")) {
    // Saudi local mobile (05xxxxxxxx) → 9665xxxxxxxx. Only rewrite when it
    // matches the local mobile shape; otherwise leave the leading zero
    // alone so international numbers stored oddly still resolve.
    if (digits.length === 10 && digits.startsWith("05")) {
      digits = "966" + digits.slice(1);
    }
  }
  if (digits.length < 8) return "";
  return digits;
}

/**
 * Build the customer-conversation wa.me URL. Returns null when the phone
 * is missing or unusable so callers can render a plain non-clickable
 * fallback instead of a broken link.
 */
export function whatsappUrl(raw) {
  const digits = normalizeWhatsappNumber(raw);
  if (!digits) return null;
  return `https://wa.me/${digits}`;
}
